import React, { useState, useEffect } from 'react';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import StrikethroughSIcon from '@material-ui/icons/StrikethroughS';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import CloseIcon from '@material-ui/icons/Close';

const Toolbar = ({ editor, onClose }) => {
  const [, setTick] = useState(0);

  // Syncs active button states on every keystroke, selection, or click
  useEffect(() => {
    if (!editor) return;

    const handleUpdate = () => {
      setTick((t) => t + 1);
    };

    editor.on('transaction', handleUpdate);
    editor.on('selectionUpdate', handleUpdate);

    return () => {
      editor.off('transaction', handleUpdate);
      editor.off('selectionUpdate', handleUpdate);
    };
  }, [editor]);

  if (!editor) return null;

  return (
    <div className="tiptap-toolbar">
      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('bold') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleBold().run();
        }}
        title="Bold (Ctrl+B)"
      >
        <FormatBoldIcon />
      </button>

      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('italic') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleItalic().run();
        }}
        title="Italic (Ctrl+I)"
      >
        <FormatItalicIcon />
      </button>

      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('underline') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleUnderline().run();
        }}
        title="Underline (Ctrl+U)"
      >
        <FormatUnderlinedIcon />
      </button>

      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('strike') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleStrike().run();
        }}
        title="Strikethrough"
      >
        <StrikethroughSIcon />
      </button>

      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('bulletList') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleBulletList().run();
        }}
        title="Bullet List"
      >
        <FormatListBulletedIcon />
      </button>

      <button
        type="button"
        className={`action-icon-btn ${
          editor.isActive('orderedList') ? 'active-format' : ''
        }`}
        onMouseDown={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleOrderedList().run();
        }}
        title="Numbered List"
      >
        <FormatListNumberedIcon />
      </button>

      <button
        type="button"
        className="action-icon-btn toolbar-close-btn"
        onMouseDown={(e) => {
          e.preventDefault();
          onClose?.();
        }}
        title="Hide Formatting Toolbar"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

Toolbar.displayName = 'Toolbar';

export default Toolbar;
